module.exports.CHESSMAN_STATE = {
    DEFAULT:0,
    BLACK:1,
    WHITE:2
};



// WEBPACK FOOTER //
// ./src/five/const.js